import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import { useDataManagement } from '../components/ferramentas/RequisitarAPI.ts';

const LayoutPrincipal = () => {
  // Estado para armazenar o nível de acesso
  const [accessLevel, setAccessLevel] = useState("");
  const { users: fetchUsers } = useDataManagement();
  
  // Obter o nível de acesso do localStorage ao carregar
  useEffect(() => {
    // Verificar o token para determinar o nível de acesso
    const setAccessLevelFunc = async () => {
      try {
        const result = await fetchUsers.getCurrentUser();
        if (result.ok) {
          setAccessLevel(result.data.access_level);
        }
      } catch (error) {
        console.error("Erro ao buscar nível de acesso:", error);
      }
    }
    setAccessLevelFunc();
  }, [fetchUsers]);
  
  return (
    <>
      <Header 
        className='header' 
        accessLevel={accessLevel}
      />
      <div className='container_interno'>
        <Outlet />
      </div>
      <Footer className='footer' />
    </>
  );
};

export default LayoutPrincipal;